async function fetchAcademicArticle(container, blogHandle, tagHandle, page = 1) {
    container.innerHTML = '<div class="ajax-loading" style="color:#888;">読み込み中...</div>';

    const viewName = 'learn-knowledge-academic-list';
    const url = `/blogs/${blogHandle}/tagged/${encodeURIComponent(tagHandle)}?view=${viewName}&page=${page}`;

    try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const html = await response.text();

        if (!html.trim()) {
            container.innerHTML = '<div class="ajax-empty" style="color: #666;">現在、該当する記事はありません。</div>';
        } else {
            container.innerHTML = html;

            // ✅ 内容插入后，初始化跳转输入框
            initAcademicPaginationJump(container);

            // 同步 URL（可选）
            const u = new URL(window.location.href);
            if (page == 1) u.searchParams.delete('page');
            else u.searchParams.set('page', page);
            history.replaceState(null, '', u.toString());
        }
    } catch (err) {
        console.error(`[失败] 标签 [${tagHandle}] 加载失败:`, err);
        container.innerHTML = '<div class="ajax-error" style="color:red;">読み込みに失敗しました。再度お試しください。</div>';
    }
}

/**
 * 初始化「输入页码跳转」，可重复调用
 */
function initAcademicPaginationJump(scope) {
    scope = scope || document;
    scope.querySelectorAll('.academic-pagination__jump').forEach(function (box) {
        if (box.dataset.jumpInit === '1') return;
        box.dataset.jumpInit = '1';

        const input = box.querySelector('.academic-pagination__jump-input');
        const btn = box.querySelector('.academic-pagination__jump-btn');
        const totalPages = parseInt(box.dataset.totalPages, 10) || 1;
        if (!input || !btn) return;

        function go() {
            const n = parseInt(input.value, 10);
            if (!n || n < 1 || n > totalPages) {
                alert(`1〜${totalPages} のページ番号を入力してください。`);
                input.focus();
                return;
            }

            const container = box.closest('.academic-list-wrapper');
            if (!container) return;
            const blogHandle = container.getAttribute('data-blog-handle');
            const tagHandle = container.getAttribute('data-tag-handle') || 'Academic';
            if (!blogHandle) return;

            fetchAcademicArticle(container, blogHandle, tagHandle, n);
        }

        btn.addEventListener('click', go);
        input.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                go();
            }
        });
    });
}

document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('.academic-list-wrapper');
    if (!container) return;

    const blogHandle = container.getAttribute('data-blog-handle');
    const tagHandle = container.getAttribute('data-tag-handle') || 'Academic';

    if (!blogHandle) {
        console.error('容器 .academic-list-wrapper 缺少 data-blog-handle 属性');
        return;
    }

    // 初始加载：读 URL 上的 page，没有就 1
    const initialPage = parseInt(new URL(window.location.href).searchParams.get('page'), 10) || 1;
    fetchAcademicArticle(container, blogHandle, tagHandle, initialPage);

    // 统一拦截分页按钮点击（前へ / 次へ / 页码数字）
    document.addEventListener('click', (e) => {
        const pageBtn = e.target.closest('.page-btn');
        if (!pageBtn || !container.contains(pageBtn)) return;
        if (pageBtn.classList.contains('is-disabled') || pageBtn.classList.contains('is-current')) return;

        e.preventDefault();

        const href = pageBtn.getAttribute('href');
        let page = 1;
        if (href) {
            const urlObj = new URL(href, window.location.origin);
            const pageParam = urlObj.searchParams.get('page');
            if (pageParam) page = pageParam;
        }

        fetchAcademicArticle(container, blogHandle, tagHandle, page);
    });
});

/*
async function fetchAcademicArticle(container, blogHandle, tagHandle, page = 1) {
    // 1. 显示加载中
    container.innerHTML = '<div class="ajax-loading" style="color:#888;">読み込み中...</div>';

    // const tagHandle = 'Academic';
    const viewName = 'learn-knowledge-academic-list'; // 对应的 liquid 模板名
    const url = `/blogs/${blogHandle}/tagged/${encodeURIComponent(tagHandle)}?view=${viewName}&page=${page}`;

    try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        
        const html = await response.text();
        
        // 2. 渲染结果
        if (!html.trim()) {
            container.innerHTML = '<div class="ajax-empty" style="color: #666;">現在、該当する記事はありません。</div>';
        } else {
            container.innerHTML = html;
            // 如果有滚动条，可以顺便让页面平滑滚动到列表顶部
            // container.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    } catch (err) {
        console.error(`[失败] 标签 [${tagHandle}] 加载失败:`, err);
        container.innerHTML = '<div class="ajax-error" style="color:red;">読み込みに失敗しました。再度お試しください。</div>';
    }
}


document.addEventListener('DOMContentLoaded', () => {
    
    // 找到页面对应的容器
    const container = document.querySelector('.academic-list-wrapper'); // 👈 请确保页面 HTML 中有这个 class
    if (!container) return; // 如果页面没有这个容器，直接退出
    // 获取博客 Handle
    const blogHandle = container.getAttribute('data-blog-handle');
    // 从容器获取 tagHandle
    const tagHandle = container.getAttribute('data-tag-handle') || 'Academic';
    console.log(tagHandle, 'ooooooooo')
    if (!blogHandle) {
        console.error('容器 .academic-list-wrapper 缺少 data-blog-handle 属性');
        return;
    }

    // 初始加载第一页
    fetchAcademicArticle(container, blogHandle, tagHandle, 1);

    // ====== 使用 document 绑定点击事件 ======
    document.addEventListener('click', (e) => {
        // 检查点击的目标是不是分页按钮
        const pageBtn = e.target.closest('.page-btn');
        
        // 如果点击的是分页按钮，且它在我们的 container 里面
        if (pageBtn && container.contains(pageBtn)) {
            e.preventDefault(); // 阻止默认跳转
            
            // === 从 href 中提取 page 参数 ===
            const href = pageBtn.getAttribute('href');
            let page = 1;
            
            if (href) {
                // 利用 URL 对象解析链接
                const urlObj = new URL(href, window.location.origin);
                const pageParam = urlObj.searchParams.get('page');
                if (pageParam) {
                    page = pageParam;
                }
            }
            
            console.log('准备加载页码:', page);
            
            fetchAcademicArticle(container, blogHandle, tagHandle, page);
        }
    });
});
*/